export default {
  methods: {
    setHeader(title, description, splitter=false){
      if(splitter != false){
        title = title + " | sportsstyle"
      }
      document.title = title
      document.querySelector("meta[property='og:title']").setAttribute('content', title)
      document.querySelector("meta[name='description']").setAttribute('content', description)
      document.querySelector("meta[property='og:description']").setAttribute('content', description)
    },
    setPaginate(routeName, routeParams, pageNum, seachWord=null) {
      if(seachWord != null){
        this.$router.push({ name: routeName, params: routeParams, query:{key: seachWord, page: pageNum}})
      }else{
        this.$router.push({ name: routeName, params: routeParams, query:{page: pageNum}})
      }
    }
  }
}
